import { createAction, props } from '@ngrx/store';

export const ORGANIZATION_SUCCESS = '[Login Page] Organization Success';

export const organizationSuccess = createAction(
  ORGANIZATION_SUCCESS,
  props<any>()
)